import { useSyncExternalStore } from 'react'

const pending = new Set<symbol>()
const listeners = new Set<() => void>()
const emit = () => listeners.forEach(listener => listener())

/** Each initial page request owns a token; late responses cannot clear another request. */
export function beginPageLoad() {
  const token = Symbol('page-load')
  pending.add(token)
  emit()
  return () => { if (pending.delete(token)) emit() }
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
export const getPageLoading = () => pending.size > 0
export function usePageLoading() {
  return useSyncExternalStore(subscribe, getPageLoading, () => false)
}
